import React from 'react';

interface SkeletonLoaderProps {
  variant?: 'text' | 'rectangular' | 'circular' | 'card';
  width?: string;
  height?: string;
  className?: string;
  count?: number;
}

const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({
  variant = 'rectangular',
  width = '100%',
  height,
  className = '',
  count = 1,
}) => {
  const baseClass = 'animate-pulse bg-gray-300 dark:bg-gray-700';

  const variants = {
    text: 'h-4 rounded',
    rectangular: 'rounded-lg',
    circular: 'rounded-full',
    card: 'rounded-xl',
  };

  const defaultHeights = {
    text: '1rem',
    rectangular: '12rem',
    circular: '3rem',
    card: '20rem',
  };

  const skeletonHeight = height || defaultHeights[variant];

  const Skeleton = () => (
    <div
      className={`${baseClass} ${variants[variant]} ${className}`}
      style={{
        width,
        height: skeletonHeight,
      }}
    />
  );

  return (
    <>
      {[...Array(count)].map((_, index) => (
        <Skeleton key={index} />
      ))}
    </>
  );
};

export const CardSkeleton: React.FC = () => (
  <div className="bg-white dark:bg-gray-800 rounded-xl p-6 space-y-4 shadow-lg">
    <SkeletonLoader variant="rectangular" height="12rem" />
    <SkeletonLoader variant="text" width="80%" />
    <SkeletonLoader variant="text" width="60%" />
    <SkeletonLoader variant="text" width="90%" />
  </div>
);

export const ListSkeleton: React.FC<{ count?: number }> = ({ count = 5 }) => (
  <div className="space-y-3">
    {[...Array(count)].map((_, index) => (
      <div key={index} className="flex items-center space-x-4">
        <SkeletonLoader variant="circular" width="3rem" height="3rem" />
        <div className="flex-1 space-y-2">
          <SkeletonLoader variant="text" width="70%" />
          <SkeletonLoader variant="text" width="40%" />
        </div>
      </div>
    ))}
  </div>
);

export default SkeletonLoader;
